// extracted by mini-css-extract-plugin
module.exports = {"title":"registration-form_title__3ioCq","text":"registration-form_text__2oh6U","link":"registration-form_link__HUMNk","terms":"registration-form_terms__2YBe1"};